if (!customElements.get('ms-founders-gift-form')) {
  customElements.define(
    'ms-founders-gift-form',
    class MsFoundersGiftForm extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.checkbox = this.querySelector('[data-ms-gift-checkbox]');
        this.fields = this.querySelector('[data-ms-gift-fields]');
        this.live = this.querySelector('[data-ms-gift-live]');
        this.emailInput = this.querySelector('[data-ms-gift-email]');
        this.emailMirror = this.querySelector('[data-ms-gift-email-mirror]');
        this.nameInput = this.querySelector('[data-ms-gift-name]');
        this.messageInput = this.querySelector('[data-ms-gift-message]');

        if (!this.checkbox || !this.fields) return;

        this.checkbox.addEventListener('change', () => this.sync());
        this.emailInput?.addEventListener('input', () => this.mirrorEmail());
        this.closest('form')?.addEventListener('submit', (event) => {
          const check = this.validate();
          if (check.ok) return;
          event.preventDefault();
          event.stopPropagation();
          this.emailInput?.reportValidity?.();
          this.emailInput?.focus?.();
          window.alert(check.message);
        });
        this.sync();
      }

      sync() {
        const on = this.checkbox.checked;
        this.fields.hidden = !on;
        this.toggleInputs(on);
        this.syncHiddenFlags(on);

        if (this.live) {
          this.live.textContent = on
            ? 'Gift recipient fields expanded'
            : 'Gift recipient fields collapsed';
        }

        if (!on) this.clear();
      }

      toggleInputs(enabled) {
        [this.emailInput, this.emailMirror, this.nameInput, this.messageInput].forEach((el) => {
          if (!el) return;
          el.disabled = !enabled;
          if (enabled) {
            el.removeAttribute('disabled');
          } else {
            el.setAttribute('disabled', 'disabled');
          }
        });
        this.mirrorEmail();
      }

      mirrorEmail() {
        if (!this.emailMirror) return;
        this.emailMirror.value = (this.emailInput?.value || '').trim();
      }

      /** Hidden flags so native product-form submits also mark the gift for Flow. */
      syncHiddenFlags(on) {
        this.querySelectorAll('[data-ms-gift-flag]').forEach((el) => el.remove());
        if (!on) return;

        const flags = [
          ['properties[Gift]', 'Yes'],
          ['properties[_ms_gift]', '1'],
        ];
        flags.forEach(([name, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          input.setAttribute('data-ms-gift-flag', '');
          this.appendChild(input);
        });
      }

      clear() {
        if (this.emailInput) this.emailInput.value = '';
        if (this.nameInput) this.nameInput.value = '';
        if (this.messageInput) this.messageInput.value = '';
      }

      isGift() {
        return Boolean(this.checkbox?.checked);
      }

      getValues() {
        return {
          email: (this.emailInput?.value || '').trim(),
          name: (this.nameInput?.value || '').trim(),
          message: (this.messageInput?.value || '').trim(),
        };
      }

      validate() {
        if (!this.isGift()) return { ok: true };

        const { email } = this.getValues();
        if (!email) {
          return { ok: false, message: 'Enter the recipient email so we can invite them to the Founders Circle.' };
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          return { ok: false, message: 'Enter a valid recipient email address.' };
        }
        return { ok: true };
      }

      /**
       * Append cart line-item properties for Shopify Flow.
       * @param {FormData} formData
       */
      appendToFormData(formData) {
        if (!this.isGift() || !formData) return;

        const { email, name, message } = this.getValues();
        formData.append('properties[Gift]', 'Yes');
        formData.append('properties[_ms_gift]', '1');
        formData.append('properties[Recipient email]', email);
        formData.append('properties[_ms_gift_recipient_email]', email);
        if (name) formData.append('properties[Recipient name]', name);
        if (message) formData.append('properties[Gift message]', message);
      }
    }
  );
}

/**
 * Find a gift form scoped to a tier/product root (or the nearest page form).
 * @param {ParentNode|null} root
 * @returns {MsFoundersGiftForm|null}
 */
function msFindFoundersGiftForm(root) {
  const scoped = root?.querySelector?.('[data-ms-founders-gift]');
  if (scoped) return scoped;
  return document.querySelector('[data-ms-founders-gift]');
}

window.msFindFoundersGiftForm = msFindFoundersGiftForm;
